import Panel from "../../../components/layout/panel/Panel";

const HomepageDashboard = () => {

    return (
        <Panel>
            Dashboard
        </Panel>
    );
}

export default HomepageDashboard;